import { useDispatch} from 'react-redux';
import { setPage } from '../../store/AppSlice';
import '../../css/base.css';
import home1_large from '../../img/home1_large.jpg'
import home1_medium from '../../img/home1_medium.jpg'
import home1_small from '../../img/home1_small.jpg'
import cottage3_large from '../../img/cottage/cottage3_large.jpg'
import cottage3_medium from '../../img/cottage/cottage3_medium.jpg'
import cottage3_small from '../../img/cottage/cottage3_small.jpg'
import scenery4_large from '../../img/scenery4_large.jpg'
import scenery4_medium from '../../img/scenery4_medium.jpg'
import scenery4_small from '../../img/scenery4_small.jpg'
import arnisdaleSunrise_small from '../../img/arnisdaleSunrise_small.jpg'
import arnisdaleSunrise_medium from '../../img/arnisdaleSunrise_medium.jpg'
import arnisdaleSunrise_large from '../../img/arnisdaleSunrise_large.jpg'
import clearWater_small from '../../img/clearWater_small.jpg'
import clearWater_medium from '../../img/clearWater_medium.jpg'
import clearWater_large from '../../img/clearWater_large.jpg'
import user1 from '../../img/icon/user1.png';
import dog1 from '../../img/icon/dog1.png';
import sea from '../../img/icon/sea.png';
import laundry from '../../img/icon/laundry.png';
import dishwasher from '../../img/icon/dishwasher.png';
import mountain from '../../img/icon/mountain.png';
import picketFence from '../../img/icon/picket-fence.png';
import fire from '../../img/icon/fire.png';
import boots from '../../img/icon/boots.png';
import carCharger from '../../img/icon/charging-station.png';

const Home = () => {
  const dispatch = useDispatch();
    
  return (
    <div className="row">
      <div className="col-12 col-md-5 col-lg-5 order-1 order-md-1 imagesBackgroundColour home-text-padding">
        <div className="generalText">
          <div className="generalTextBox">
            <p style={{"marginBottom": "0.5rem"}}>Shore Cottage is right on the edge of Loch Hourn in the village of Arnisdale. From the front door you can kayak for hours on Loch Hourn, even crossing over the loch to the remote and wild Knoydart
              Peninsula. From the village you can walk up into the mountains, with a path leading to the munro Beinn Sgritheall standing high
              above the village at 974m. It is a nature lovers paradise with seals and porpoises spotted regularly from the cottage and otters if you are lucky.
            </p>
            <div className="row">
              <div className="col-1">
                <img src={user1} alt="User" width="25" height="25" />
              </div>
              <div className="col-5">
                <p className="icon-text">Sleeps 5</p>
              </div>
              <div className="col-1">
                <img src={picketFence} alt="garden" width="25" height="25" />
              </div>
              <div className="col-5">
                <p className="icon-text">Enclosed garden</p>
              </div>
            </div>
            <div className="row">
              <div className="col-1">
                <img src={carCharger} alt="electric car charger" width="25" height="25" />
              </div>
              <div className="col-5">
                <p className="icon-text">Electric car charger</p>
              </div>
              <div className="col-1">
                <img src={fire} alt="log fire" width="25" height="25" />
              </div>
              <div className="col-5">
                <p className="icon-text">Open fire</p>
              </div>
            </div>
            <div className="row">
              <div className="col-1">
                <img src={dog1} alt="Dog" width="25" height="25" />
              </div>
              <div className="col-5">
                <p className="icon-text">2 pets</p>
              </div>
              <div className="col-1">
                <img src={boots} alt="drying room" width="25" height="25" />
              </div>
              <div className="col-5">
                <p className="icon-text">Drying room</p>
              </div>
            </div>
            <div className="row">
              <div className="col-1">
                <img src={sea} alt="lochside" width="25" height="25" />
              </div>
              <div className="col-5">
                <p className="icon-text">Lochside</p>
              </div>
              <div className="col-1">
                <img src={dishwasher} alt="dishwasher" width="25" height="25" />
              </div>
              <div className="col-5">
                <p className="icon-text">Dishwasher</p>
              </div>
            </div>
            <div className="row">
              <div className="col-1">
                <img src={mountain} alt="mountain scenery" width="25" height="25" />
              </div>
              <div className="col-5">
                <p className="icon-text">Mountain scenery</p>
              </div>
              <div className="col-1">
                <img src={laundry} alt="washer" width="25" height="25" />
              </div>
              <div className="col-5">
                <p className="icon-text">Washer / Dryer</p>
              </div>
            </div>
            <div className="row">
            <div className="col-4"/>
              <div className="col-4 selected-week-book-btn-col">
                <p className="book-selected-date-button" style={{"marginBottom": "0", "marginLeft":"-1rem"}}>
                  <span className="navigate-span">
                    <a className="your-details-button" onClick={() => { dispatch(setPage("BOOKING"))}}>Book</a>
                  </span>
                </p>
              </div>          
              <div className="col-4"/>
            </div>  
          </div>
        </div>
      </div>
      <div className="col-12 col-md-7 col-lg-7 order-2 order-md-2 imagesBackgroundColour home-image">
        <picture>
          <source srcSet={`${cottage3_small} 1x,${cottage3_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${cottage3_medium} 1x,${cottage3_large} 2x`}
            src={cottage3_large} alt="Shore Cottage" className="image"
          />
        </picture>
      </div>
      <div className="col-12 col-md-5 col-lg-4 order-3 order-md-3 imagesBackgroundColour home-text-padding">
        <div className="generalText">
          <div className="generalTextBox">
            <p >The cottage itself is a traditional, heritage build. Upon entering this detached property via the front door, you have an inviting living room to the left with an open fire and large television. 
              The other side of the house from the living room is the spacious kitchen/dining room. Off the 
              kitchen is a utility and boot room with access to the rear of the cottage. Also on the ground floor is a large family bathroom. 
              Upstairs there are three bedrooms which are all fresh, white and have plenty of light thanks to cleverly positioned windows. 
              The garden is fully enclosed at the rear, and there is garden furniture as well as a charcoal barbecue.
            </p>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-7 col-lg-8 order-4 order-md-4 imagesBackgroundColour home-image">
        <picture>
          <source srcSet={`${arnisdaleSunrise_small} 1x,${arnisdaleSunrise_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${arnisdaleSunrise_medium} 1x,${arnisdaleSunrise_large} 2x`}
            src={arnisdaleSunrise_large} alt="Arnisdale Sunrise" className="image"
          />
        </picture>
      </div>
      <div className="col-12 col-md-7 col-lg-8 order-6 order-md-5 imagesBackgroundColour home-image">
        <picture>
          <source srcSet={`${clearWater_small} 1x,${clearWater_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${clearWater_medium} 1x,${clearWater_large} 2x`}
            src={clearWater_medium} alt="Kayaking from Shore Cottage" className="image"
          />
        </picture>
      </div>
      <div className="col-12 col-md-5 col-lg-4 order-5 order-md-6 imagesBackgroundColour home-text-padding">
        <div className="generalText">
          <div className="generalTextBox">
            <p>Arnisdale is found at the end of a 10-mile single track road running south from Glenelg. It is one of the most remote outposts 
            in mainland Scotland. The main road through Arnisdale is a gentle curving lane running parallel to the shingle beach. 
            Beyond Arnisdale Lodge, which was built in 1898 by Valentine Fleming, father of Ian Fleming, author of the James Bond 007 books, 
            the road continues half a mile to the village of Corran. You will find the attractive Ceilidh House and Heritage Centre which opened
            in 2008 and gives a history of the area. 
            Also in Corran you will find a café serving lunches and drinks throughout the day.
            </p>
            <p>Arnisdale is a gateway to the mountainous Knoydart Peninsula. A boat can be arranged locally to take you across to golden sands
             of Barrisdale on the far side of Loch Hourn, from where Knoydart can be explored. Back towards Glenelg with its marvellous inn,
              there is a little track down to Sandaig and the memorial site of the cottage in which the author Gavin Maxwell lived whilst writing
               ’Ring of Bright Water’ in 1960. It is still magical place where otters can still be seen. 
                It is remote at Shore Cottage, but once you have arrived you will not want to leave. Shop, pub and restaurant 9 miles.
            </p>
          </div>
        </div>
      </div>
    </div>
  );

}

/*
      <div className="col-12 col-md-7 col-lg-8 order-4 order-md-4 imagesBackgroundColour home-image">
        <picture>
          <source srcSet={`${home1_small} 1x,${home1_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${home1_medium} 1x,${home1_large} 2x`}
            src={home1_large} alt="Arnisdale Village" className="image"
          />
        </picture>
      </div>
      <div className="col-12 col-md-7 col-lg-8 order-6 order-md-5 imagesBackgroundColour home-image">
        <picture>
          <source srcSet={`${scenery4_small} 1x,${scenery4_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${scenery4_medium} 1x,${scenery4_large} 2x`}
            src={scenery4_medium} alt="Kayaking at Dry Island" className="image"
          />
        </picture>
      </div>

*/

export default Home
